/* DEV NOTE: this file us used for other AVG pages:
/report-malicious-file
*/

(function() {
	'use strict';

	var forms = document.querySelectorAll('.section-form');
	if (forms) {
		forms.forEach(function (form){
			if (form.querySelectorAll('.avast-form').length > 0) {
				var
					togglers = form.querySelectorAll('.form-controler .toggler-item'),
					radios = form.querySelectorAll('.avast-form input[type=radio]'),
					defaultSelection = form.querySelector('.form-controler .toggler-item.selected'),
					defaultTarget = defaultSelection.getAttribute('target'),

					togglerSwitch = function(togglers, toggler, radios) {
						togglers.forEach(function(item){
							item.classList.remove('selected');
						});

						toggler.classList.add('selected');
						var target = toggler.getAttribute('target');
						
						setInputsVisibility(target);
						setRadios(radios, target);
					},

					setInputsVisibility = function(target) {
						var
							inputUrl = form.querySelector('.avast-form input[name=url]'),
							inputFile = form.querySelector('.avast-form input[name=file]');
						
						inputUrl.closest('tr').classList.add('hidden');
						inputFile.closest('tr').classList.add('hidden');

						// 'target' param indicates that method was called by toggler switch (initial input hiding is done by forms-fetch.js)
						if(target && target == 'website'){
							inputUrl.closest('tr').classList.remove('hidden');
						} else if(target && target == 'file'){
							inputFile.closest('tr').classList.remove('hidden');
						}
					},
				
					// Set the proper radio checked according to togglers; needed for backend processing of the form
					setRadios = function(radios, target) {
						radios.forEach(function (radio){
							radio.removeAttribute('checked'); // reset radios
							radio.checked = false; // reset radios
						});
				
						for (var i = 0; i < radios.length; i++) {
							if (target == radios[i].value) {
								radios[i].setAttribute('checked','');
								radios[i].checked = true;
								break;
							}
						};
					};

				setInputsVisibility(defaultTarget);

				togglers.forEach(function(toggler){
					toggler.addEventListener("click", function(){
						togglerSwitch(togglers, this, radios);
					});
				});
			}
		});
		
		// Init tooltip
		window.addEventListener("load", function(){
			document.querySelectorAll("td .tooltip-w").forEach(function(tooltip){
				const tooltipParent = tooltip.parentElement;
				const mainParent = tooltipParent.parentElement.firstElementChild;

				// add info icon
				var i = document.createElement('span');
				i.setAttribute('role', 'img');
				i.classList.add('tooltip-icon');

				mainParent.appendChild(i);

				tooltip.classList.add('hidden');

				// Hover tooltip
				mainParent.addEventListener("mouseover", function(){
					tooltip.classList.remove('hidden');
				});
				mainParent.addEventListener("mouseout", function(){
					tooltip.classList.add('hidden');
				});
				
			});
		});
	}
})();

